import { Link } from 'react-router-dom'
import { LogOut, User, Settings, Store } from 'lucide-react'
import { useAuthStore } from '../stores/authStore'
import { useTheme } from '../contexts/ThemeContext'

export default function DashboardHeader() {
  const { user, logout } = useAuthStore()
  const { currentTheme } = useTheme()
  const logoSrc = currentTheme?.is_dark ? '/DashitLogo-white.png' : '/DashitLogo.png'

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="px-3">
        <div className="flex items-center justify-between h-10">
          <div className="flex items-center gap-6">
            <Link to="/" className="flex items-center gap-2">
              <img
                src={logoSrc}
                alt="Dashit"
                className="h-6 w-auto"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                  e.currentTarget.nextElementSibling.style.display = 'block';
                }}
              />
              <span className="text-lg font-bold text-primary-600 hidden">Dashit</span>
            </Link>
            
            <nav className="hidden md:flex gap-4">
              <Link
                to="/"
                className="text-sm text-gray-600 hover:text-gray-900 transition"
              >
                Dashboard
              </Link>
              <Link
                to="/app-store"
                className="text-sm text-gray-600 hover:text-gray-900 transition flex items-center gap-1"
              >
                <Store size={14} />
                App Store
              </Link>
              {user?.role === 'developer' && (
                <Link
                  to="/developer"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  Developer Portal
                </Link>
              )}
              {user?.role === 'admin' && (
                <Link
                  to="/admin"
                  className="text-sm text-gray-600 hover:text-gray-900 transition"
                >
                  Admin
                </Link>
              )}
            </nav>
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/profile"
              className="flex items-center gap-2 text-gray-700 text-sm hover:text-gray-900 transition"
              title="Profile Settings"
            >
              <User size={16} />
              <span>{user?.first_name || user?.email?.split('@')[0]}</span>
            </Link>
            
            <button
              onClick={logout}
              className="flex items-center gap-1 px-3 py-1 text-sm text-gray-700 hover:bg-gray-100 rounded transition"
            >
              <LogOut size={14} />
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  )
}

